import { useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { SignIn, ArrowLeft } from "@phosphor-icons/react";
import { useAuth } from "@/context/AuthContext";

export default function Login() {
  const { user, loading, login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && user?.is_admin) navigate("/admin", { replace: true });
  }, [user, loading, navigate]);

  return (
    <div className="min-h-screen bg-gray-950 text-white grid lg:grid-cols-2">
      <div className="relative hidden lg:block">
        <img
          src="https://images.unsplash.com/photo-1515263487990-61b07816b324?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400"
          alt="Construction"
          className="absolute inset-0 w-full h-full object-cover opacity-40"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-gray-950 via-gray-950/40 to-transparent" />
        <div className="relative h-full flex flex-col justify-end p-12">
          <img src="/logo-white.png" alt="Mountain Core" className="h-12 w-auto mb-6" />
          <p className="text-gray-300 max-w-sm text-sm leading-relaxed">
            Contractor access. Manage consultation requests and update your website content in one place.
          </p>
        </div>
      </div>

      <div className="flex flex-col justify-center px-8 sm:px-16 py-16">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-gray-400 hover:text-white transition-colors duration-200 mb-12" data-testid="login-back-home">
          <ArrowLeft size={16} /> Back to website
        </Link>
        <span className="text-xs font-bold uppercase tracking-[0.28em] text-gray-500">Mountain Core</span>
        <h1 className="mt-4 font-heading text-4xl font-bold tracking-tight">Contractor Sign In</h1>
        <p className="mt-4 text-gray-400 text-sm max-w-sm leading-relaxed">
          Sign in to manage consultation requests and update your website content.
        </p>
        <button
          onClick={login}
          data-testid="google-login-button"
          className="mt-10 inline-flex items-center justify-center gap-3 bg-white text-gray-950 font-semibold px-6 py-4 rounded-sm hover:bg-gray-200 transition-colors duration-200 w-full sm:w-auto"
        >
          <SignIn size={20} weight="bold" />
          Sign In
        </button>
        <p className="mt-8 text-xs text-gray-600 max-w-sm">
          Authorized contractor access only.
        </p>
      </div>
    </div>
  );
}
